export default "__VITE_ASSET__27hkUccY__"